import { render, staticRenderFns } from "./MpAnimation.vue?vue&type=template&id=587432ae&scoped=true&"
import script from "./MpAnimation.vue?vue&type=script&lang=js&"
export * from "./MpAnimation.vue?vue&type=script&lang=js&"
import style0 from "./MpAnimation.vue?vue&type=style&index=0&id=587432ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587432ae",
  null
  
)

export default component.exports